import { render, staticRenderFns } from "./ModalConfirmarReordenarDocumento.vue?vue&type=template&id=7f0ecec3&scoped=true"
import script from "./ModalConfirmarReordenarDocumento.vue?vue&type=script&lang=js"
export * from "./ModalConfirmarReordenarDocumento.vue?vue&type=script&lang=js"
import style0 from "./ModalConfirmarReordenarDocumento.vue?vue&type=style&index=0&id=7f0ecec3&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0ecec3",
  null
  
)

export default component.exports